import { GeneralPostForm } from './GeneralPostForm';

export default function GeneralPostPage() {
  return (
    <div className="w-full max-w-5xl mx-auto px-0 md:px-4 py-0 md:py-6">
      <GeneralPostForm />
    </div>
  );
}
